import React from 'react';
import SettingsLayout from './SettingsLayout';
import TeamSection from './TeamSection';

/** /hirewithus/settings/team — invite colleagues and manage their roles. */
const TeamPage = () => (
  <SettingsLayout
    activeKey="team"
    title="Settings"
    description="Give each colleague their own login and a role that matches what they do."
  >
    <TeamSection />
  </SettingsLayout>
);

export default TeamPage;
